// eslint-disable-next-line @typescript-eslint/ban-types
export const isFunction = (arg: any): arg is Function => typeof arg === 'function'
